import React from "react";
import About from "../components/About";
import Clients from "../components/Clients";
import Header from "../components/Header";
import Hero from "../components/Hero";
import KeyFeatures from "../components/KeyFeatures";
import Pricing from "../components/Pricing";
import Review from "../components/Review";

export default function Home() {
	return (
		<div className="bg-zinc-200">
			<Header />
			<Hero />
			<Clients />
			{/* <About /> */}
			<KeyFeatures />
			<Pricing />
			<Review />
		</div>
	);
}
